import React from "react";
import PropTypes from 'prop-types';

var ShareLinkedIn = function ShareLinkedIn(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 18 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 18 : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#1D2327' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3389 15.3384H12.6694V11.1608C12.6694 10.1648 12.6524 8.88325 11.2823 8.88325C9.89277 8.88325 9.68077 9.96878 9.68077 11.0898V15.3384H7.01419V6.74819H9.57327V7.92272H9.61027C9.96628 7.2472 10.8373 6.53518 12.1358 6.53518C14.8394 6.53518 15.3389 8.31373 15.3389 10.6273V15.3384ZM4.00411 5.57465C3.14659 5.57465 2.45507 4.88114 2.45507 4.02611C2.45507 3.17159 3.14659 2.47807 4.00411 2.47807C4.85814 2.47807 5.55115 3.17159 5.55115 4.02611C5.55115 4.88114 4.85814 5.57465 4.00411 5.57465ZM2.66707 15.3384H5.33965V6.74819H2.66707V15.3384ZM16.6685 0H1.32754C0.595016 0 0 0.581016 0 1.29804V16.7015C0 17.4185 0.595016 18.0005 1.32754 18.0005H16.6685C17.4025 18.0005 18 17.4185 18 16.7015V1.29804C18 0.581016 17.4025 0 16.6685 0Z",
    fill: fill
  }));
};

ShareLinkedIn.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
};
export default ShareLinkedIn;